import C from "../constants";

export default function user(state = {}, payload) {
  let { type, key, data } = payload;
  switch (type) {
    case C.UPDATE_USER_INFO:
      return { ...state, [key]: data };
    case C.UPDATE_USER_INFO_DSS:
      return {
        ...state,
        ...data,
      };
    case C.UPDATE_ALERT:
      return {
        ...state,
        alertInfo: { ...data },
      };
    case C.UPDATE_SCREEN:
      return {
        ...state,
        screen: { ...data },
      };
    case C.TOGGLE_SIDEBAR:
      return {
        ...state,
        screen: {
          ...state.screen,
          isSidenavBarExpanded: !state.screen.isSidenavBarExpanded,
        },
      };
    default:
      return state;
  }
}
